import React, { useEffect, useState, useRef } from "react";
import label from "../../labels/interviewProcess_en.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { DatePicker } from "antd";
import html2pdf from "html2pdf.js";
import moment from "moment";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import dayjs from "dayjs";
import { toastr } from "react-redux-toastr";


import { format } from "date-fns";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslist,
  getExamslistByAdvertisementId,
  getInterviewScrutinyCandidates,
  getSubjectlistByExamId,
  getdownloadCandidateList,
  saveInterviewStatus,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getInterviewQualifiedCandidateData,
  getVenueList,
  printInterviewSchedulesData,
  saveAddScheduleData,
  updateScheduleData,
  getInterviewScheduleLetterByExamId
} from "../../actions/interviewProcessActions";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  getYearList,
  getMainsAdvertisements,
} from "../../../common/actions/commonActions";

import InterviewScheduleApprovalEntity from "./InterviewScheduleApprovalEntity";
import TablePagination from "../../../common/components/TablePagination";
import { getAllApprovalInterviewSchedulePagination } from "../../../recommendationProcess/actions/recommendationProcessActions";


const GenerateInterviewSchedule = () => {
  const pdfRef = useRef(null);
  const dateFormat = "YYYY/MM/DD";

  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    // "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];


  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });
  let { allReservationData, venueList, interviewQualifiedCandidateData } =
    useSelector((state) => state.interviewProcessReducer, shallowEqual);

  let { allExamList, examList, advertisementList, subjectList, allUnapprovalEntityList, unapprovalPageNoCounter, interviewScrutinyCandidates } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { getInterviewLetter } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  let tableCounter_unapproval = unapprovalPageNoCounter + 1;
  let rowPerPage = 10;

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [editedValues, setEditedValues] = useState({});
  const [saveMode, setSaveMode] = useState(false);
  const [data, setData] = useState({});
  const [selectedUploadFile, setSelectedUploadFile] = useState("");
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [stepName, setName] = useState("AddSchedule");
  const [selectedDate, setSelectedDate] = useState("");
  const [qualifiedButton, setQualifiedButton] = useState(true);
  const [pdfPrintDisabled, setPdfPrintDisabled] = useState(false);
  const date = new Date(); // Your date object here
  const formattedDate = format(date, "MM/dd/yyyy");
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [interviewData, setInterviewData] = useState([]);
  const [scrutinyCandidates, setScrutinyCandidates] = useState([]);  // const [updateFlag, setUpdateFlag] = useState(false);

  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedAdvertisement, setSelectedAdvertisement] = useState("");
  const [isScrutinyLocked, setIsScrutinyLocked] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    // dispatch(getExamslist());
    // dispatch(getVenueList());
    dispatch(getYearList());
    setReloadItem(!reloadItem);
    onCancelButton();
    setInterviewData([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getInterviewLetter) {
      setInterviewData(getInterviewLetter);
    }
  }, [getInterviewLetter]);

  // useEffect(() => {
  //   if (interviewData.isPresent > 0) {
  //     setUpdateFlag(true);
  //   } else {
  //     setUpdateFlag(false);
  //   }
  // }, [interviewData]);

  useEffect(() => {
    if (stepName === "Approvals") {
      dispatch(getAllApprovalInterviewSchedulePagination(listCurrentPage, rowPerPage));
    }
  }, [dispatch, listCurrentPage, rowPerPage, stepName]);

  useEffect(() => {
    if (interviewScrutinyCandidates?.length > 0) {
      setScrutinyCandidates(
        interviewScrutinyCandidates.map(item => ({
          ...item,
          isSelected: false,
          isRejected: false,
          rejectionReason: ""
        }))
      );
    } else {
      setScrutinyCandidates([]);
    }
  }, [interviewScrutinyCandidates]);

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    examList.length = 0;
    subjectList.length = 0;
    setSelectedExam("");
    setSelectedSubject("");
    if (stepName === "qualifiedCandidate") {
      setQualifiedButton(true);
    }
    setSaveButtonFlag(true);
    setInterviewData([]);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    subjectList.length = 0;
    setSelectedExam(selectedValue);
    setSelectedSubject("");
    setSaveButtonFlag(false);
    if (stepName === "qualifiedCandidate") {
      setQualifiedButton(false);
    }
    selectedValue && dispatch(getInterviewScheduleLetterByExamId(selectedValue));
    // dispatch(getInterviewQualifiedCandidateData(selectedValue));
    if (
      interviewQualifiedCandidateData &&
      interviewQualifiedCandidateData.interview &&
      interviewQualifiedCandidateData.interview.length > 0
    ) {
      setPdfPrintDisabled(true);
    } else {
      setPdfPrintDisabled(false);
    }
    setInterviewData([]);
    setReloadItem(!reloadItem);
  };

  const onSubjectChange = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    setSaveButtonFlag(false);
    // selectedValue && dispatch(getReservationData(selectedExam, selectedValue));
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    setSaveMode(true);
    reset();
    setSelectedYear("");
    setSelectedAdvertisement("");
    setSelectedDate("");
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSaveButtonFlag(true);
    setIsFileSelected(false);
    setReloadItem(!reloadItem);
    setInterviewData([]);
    examList.length = 0;
    subjectList.length = 0;
    allReservationData.length = 0;
    getInterviewLetter.length = 0;
  };

  const downloadPdf = () => {
    let headData = [[label.Category, label.SubCategory, label.ReservedSeats]];
    let rowData = allReservationData.criteria.map((marksDt) => {
      return {
        barcodeNo: marksDt.category,
        rollNo: marksDt.subCategory,
        marks: marksDt.reservedSeats,
      };
    });
    let headdt = {
      exam_name: "Exam Name",
      subject_name: "Subject Name",
      STUDENT_COUNT: 100,
    };
    let exam_name = allReservationData.examName;
    let subject_name = allReservationData.subjectNmae;
    // CustomPdfDownload(rowData, headdt, subject_name, exam_name, headData);
    setReloadItem(!reloadItem);
  };
  const printInterviewLetters = () => {
    genPdf();
    //dispatch(printInterviewSchedulesData(selectedExam));
  };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }

    setSaveButtonFlag(true);
    if (stepName === "qualifiedCandidate") {
      setQualifiedButton(true);
    }
    setReloadItem(!reloadItem);
  };
  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      interviewQualifiedCandidateData.examName +
      "</h5><h5>" +
      commonLabels.INTERVIEW_SCHEDULE +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "Interview_Letters_Schedule_.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = interviewQualifiedCandidateData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`Interview_Letters_Schedule_${selectedExam}.pdf`);
      });
  };

  const handleInputChange = (questionNo, newValue) => {
    setEditedValues((prevValues) => ({
      ...prevValues,
      [questionNo]: newValue,
    }));
  };

  const handleDateChange = (dateString) => { };

  const DownloadCandidateList = () => {
    dispatch(getdownloadCandidateList(selectedExam, downloadCSV));
  };

  function downloadCSV(resData) {
    const csvContent = "data:text/csv;charset=utf-8," + resData;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Qualified_Candidate.csv");
    document.body.appendChild(link);
    link.click();
  }

  const onUploadFileChange = (e) => {
    setIsFileSelected(e.target.files.length > 0);
    if (e.target.files.length === 0) {
      return;
    }
    setSaveButtonFlag(false);
    let selectedValue = e.target.files[0];
    setSelectedUploadFile(selectedValue);
    setReloadItem(!reloadItem);
  };

  const onChange = (value, dateString) => {
    if (dateString) {
      setSelectedDate(dateString);
    } else {
      setSelectedDate("");
    }
  };


  const onhandleAddSchedule = (e) => {
    let data = {};
    setSaveMode(true);
    data.file = selectedUploadFile;
    data.type = "importData";
    dispatch(saveAddScheduleData(selectedExam, data));
    onCancelButton();
    setInterviewData([]);
  };

  const onHandleUpdateSchedule = (e) => {
    let data = {};
    setSaveMode(true);
    data.file = selectedUploadFile;
    data.type = "importData";
    dispatch(updateScheduleData(selectedExam, data));
    onCancelButton();
    setInterviewData([]);
  };
  // const formatDate = (inputDate) => {
  //   const formattedDate = moment(inputDate)
  //   .utcOffset('+05:30')
  //   .format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (India Standard Time)');

  //   return formattedDate;
  // };
  // const inputDate = '2023-08-04T00:00:00.000+00:00';
  // const formattedDate = formatDate(inputDate);

  // function formatDate(dateString) {
  //   const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  //   return new Date(dateString).toLocaleDateString(undefined, options);
  // };

  const groupedDataByVenue = {};

  interviewData.interviewScheduleApprovalDtos?.forEach((item, index) => {

    const venueName = item.venueName || 'Unknown Venue';

    if (!groupedDataByVenue[venueName]) {
      groupedDataByVenue[venueName] = [];
    }

    groupedDataByVenue[venueName].push({
      interviewNumber: item.interviewNo,
      rollId: item.rollNo,
      candidateName: item.candidateName,
      interviewDate: item.interviewDate,
      interviewTime: item.interviewTime
    });
  });

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };

  const onScrutinyExamChange = (examId) => {
    setSelectedExam(examId);
    setIsScrutinyLocked(false);
    if (examId) {
      dispatch(getInterviewScrutinyCandidates(examId));
    }
  };

  const handleSelected = (index) => {
    const data = [...scrutinyCandidates];
    if (!data[index]) return;
    data[index].isSelected = !data[index].isSelected;
    if (data[index].isSelected) {
      data[index].isRejected = false;
      data[index].rejectionReason = "";
    }
    setScrutinyCandidates(data);
  };;

  const handleRejected = (index) => {
    const data = [...scrutinyCandidates];
    data[index].isRejected = !data[index].isRejected;
    if (data[index].isRejected) {
      data[index].isSelected = false;
    } else {
      data[index].rejectionReason = "";
    }
    setScrutinyCandidates(data);
  };

  const handleReasonChange = (index, value) => {
    const data = [...scrutinyCandidates];
    data[index].rejectionReason = value;
    setScrutinyCandidates(data);
  };

  const handleScrutinySave = async () => {
    const payload = {
      examId: Number(selectedExam),
      candidates: scrutinyCandidates
        .filter(item => item.isSelected || item.isRejected)
        .map(item => ({
          rollNumber: item.rollNumber,
          status: item.isSelected
            ? "SELECTED"
            : item.isRejected
              ? "REJECTED"
              : "",
          rejectionComment: item.isRejected
            ? item.rejectionReason
            : ""
        }))
    };

    try {
      await dispatch(saveInterviewStatus(payload));
      toastr.success("Interview status saved successfully.");
      setIsScrutinyLocked(true);
      setSelectedYear("");
      setSelectedAdvertisement("");
      setSelectedExam("");
    } catch (error) {
      toastr.error("Failed to save interview status.");
    }
  };

  return (
    <div className="commonContentArea">
      <h5> {label.GenerateInterviewSchedule} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="3">
            <a
              href="#"
              className={
                stepName === "Scrutiny"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="Scrutiny"
              id="Scrutiny-tab"
              onClick={() => setName("Scrutiny")}
              data-toggle="tab"
              role="tab"
              aria-controls="Scrutiny"
              aria-selected="false"
            >
              <span>Scrutiny</span>
            </a>
          </li>
          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "qualifiedCandidate"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="qualifiedCandidate"
              id="qualifiedCandidate-tab"
              onClick={() => setName("qualifiedCandidate")}
              data-toggle="tab"
              role="tab"
              aria-controls="qualifiedCandidate"
              aria-selected="false"
            >
              <span>{label.QualifiedCandidate}</span>
            </a>
          </li>

          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "AddSchedule"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="AddSchedule"
              id="AddSchedule-tab"
              onClick={() => setName("AddSchedule")}
              data-toggle="tab"
              role="tab"
              aria-controls="AddSchedule"
              aria-selected="false"
            >
              <span>{label.AddSchedule}</span>
            </a>
          </li>

          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "Approvals"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="Approvals"
              id="Approvals-tab"
              onClick={() => setName("Approvals")}
              data-toggle="tab"
              role="tab"
              aria-controls="Approvals"
              aria-selected="false"
            >
              <span>{label.Approvals}</span>
            </a>
          </li>


        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "Scrutiny"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="Scrutiny"
            role="tabpanel"
            aria-labelledby="Scrutiny-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">

                {/* Filters */}
                <div className="form-group">
                  <div className="row">

                    {/* Year */}
                    <div className="form-group col-md-2">
                      <label>
                        {commonLabels.selectYear}
                        <span className="errorText">*</span>
                      </label>

                      <select
                        className="form-control"
                        value={selectedYear}
                        onChange={(e) => {
                          setSelectedYear(e.target.value);
                          onSelectYear(e.target.value);
                        }}
                      >
                        <option value="">
                          {commonLabels.COMBO_SELECT}
                        </option>

                        {yearList?.map((year, index) => (
                          <option key={index}>{year}</option>
                        ))}
                      </select>
                    </div>

                    {/* Advertisement */}
                    <div className="form-group col-md-5">
                      <label>
                        {commonLabels.SelectAdvertNo}
                        <span className="errorText">*</span>
                      </label>

                      <select
                        className="form-control"
                        value={selectedAdvertisement}
                        onChange={(e) => {
                          setSelectedAdvertisement(e.target.value);
                          onAdvertisementChange(e.target.value);
                        }}
                      >
                        <option value="">
                          {commonLabels.COMBO_SELECT}
                        </option>

                        {getMainsAdvertisement
                          ?.filter(
                            (ele) => !ele.isDeleted && ele.isActive
                          )
                          .map((ele, index) => (
                            <option key={index} value={ele.id}>
                              {`${ele.advertisementNo}/${ele.year} - ${ele.name}`}
                            </option>
                          ))}
                      </select>
                    </div>

                    {/* Exam */}
                    <div className="form-group col-md-4">
                      <label>
                        {label.SelectExam}
                        <span className="errorText">*</span>
                      </label>

                      <select
                        className="form-control"
                        value={selectedExam}
                        onChange={(e) => {
                          setSelectedExam(e.target.value);
                          onScrutinyExamChange(e.target.value);
                        }}
                      >
                        <option value="">
                          {commonLabels.COMBO_SELECT}
                        </option>

                        {examList
                          ?.filter(
                            (ele) => !ele.isDeleted && ele.isActive
                          )
                          .map((ele, index) => (
                            <option key={index} value={ele.id}>
                              {ele.name}
                            </option>
                          ))}
                      </select>
                    </div>

                  </div>
                </div>

                {/* Table */}
                {scrutinyCandidates.length > 0 && (
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped">
                      <thead className="thead-light">
                        <tr>
                          <th>No.</th>
                          <th>Roll Number</th>
                          <th>Candidate Name</th>
                          <th className="text-center">Is Selected</th>
                          <th className="text-center">Is Rejected</th>
                          <th>Rejection Reason</th>
                        </tr>
                      </thead>

                      <tbody>
                        {scrutinyCandidates.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.rollNumber}</td>
                            <td>{item.candidateName}</td>

                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={item.isSelected || false}
                                disabled={isScrutinyLocked}
                                onChange={() => handleSelected(index)}
                              />
                            </td>

                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={item.isRejected || false}
                                disabled={isScrutinyLocked}
                                onChange={() => handleRejected(index)}
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Rejection Reason"
                                disabled={isScrutinyLocked || !item.isRejected}
                                value={item.rejectionReason || ""}
                                onChange={(e) =>
                                  handleReasonChange(
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Buttons */}
                {scrutinyCandidates.length > 0 && (
                  <div className="row mt-3 mb-5">
                    <div className="col-md-12 text-left">
                      <button
                        type="button"
                        className="btn btn-secondary mr-2"
                        onClick={onCancelButton}
                      >
                        {commonLabels.BUTTON_CANCEL}
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleScrutinySave}
                      >
                        {commonLabels.BUTTON_SAVE}
                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
          <div
            className={
              stepName === "AddSchedule"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="AddSchedule"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear"
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option key={index}>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-5">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo"
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {getMainsAdvertisement &&
                              getMainsAdvertisement.length > 0 &&
                              getMainsAdvertisement
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className=" col-md-4">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam"
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        {/* <div className="col-md-3">
                          <label className="float-left w-100">
                            {label.SelectDate}
                            <span className="errorText">*</span>
                          </label>
                          <DatePicker
                            allowClear
                            showTime={{
                              format: "HH:mm",
                            }}
                            format="YYYY/MM/DD HH:mm"
                            value={
                              selectedDate &&
                              dayjs(selectedDate, "YYYY/MM/DD HH:mm")
                            }
                            onChange={onChange}
                          />
                        </div> */}

                        <div className="row">
                          <div className="col-md-8 ml-3 ">
                            <label className="float-left">
                              {label.SelectUploadFile}
                              <span className="errorText">*</span>
                            </label>
                            <input
                              className="form-control mt-1"
                              type="file"
                              ref={fileInputRef}
                              accept=".xlsx, .xls, .csv"
                              name="selectedUploadFile"
                              onChange={(e) => {
                                onUploadFileChange(e);
                              }}
                            />
                            {_.get("selectedAdvertiseNo.type", errors) ===
                              "required" && (
                                <p className="errorText float-left">
                                  {commonLabels.MANDATORY_FIELD_MESSAGE}
                                </p>
                              )}
                          </div>
                        </div>
                        {/* <div className=" col-md-3">
                    <label className="float-left">
                      {label.SelectSubject}
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="selectedSubject"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        onSubjectChange(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.COMBO_SELECT}
                      </option>
                      {subjectList &&
                        subjectList.length > 0 &&
                        subjectList
                          .filter(
                            (element) =>
                              element.isDeleted == false &&
                              element.isActive === true
                          )
                          .map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                    </select>
                    {/* {_.get("selectedSubject.type", errors) === "required" && (
                                                  <p className="errorText float-left">
                                                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                                                  </p>
                                              )} 
                  </div> */}
                      </div>

                      <div className="row">
                        <div className="col-md-8 mt-3">
                          <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>
                          {interviewData && interviewData.isPresent === false && (
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              // hidden={!interviewData.isPresent}
                              disabled={saveButtonFlag || !isFileSelected}
                              onClick={() => onhandleAddSchedule()}
                            >
                              {commonLabels.BUTTON_SAVE}
                            </button>
                          )}

                          {interviewData && interviewData.isPresent === true && (
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              // hidden={interviewData.isPresent}
                              disabled={saveButtonFlag || !isFileSelected}
                              onClick={() => onHandleUpdateSchedule()}
                            >
                              {commonLabels.BUTTON_UPDATE}
                            </button>
                          )}

                          {/* <button
                                    type="button"
                                    className="btn btn-primary ml-2"
                                    onClick={()=>
                                    handleSampleDownload()
                                    }
                                >
                                    {commonLabels.DOWNLOAD_SAMPLE}
                                </button> */}

                          {/* <button
                      type="button"
                      className="btn btn-primary mr-2"
                      disabled={saveButtonFlag || !editMode}
                      onClick={() => {
                        onConfirm();
                      }}
                    >
                      {commonLabels.BUTTON_CONFIRM}
                    </button> */}
                          {/* {(session.roleName === "superadmin" ||
                            session.roleName === "secretary") &&
                            interviewQualifiedCandidateData &&
                            interviewQualifiedCandidateData.interviewLetters &&
                            interviewQualifiedCandidateData.interviewLetters
                              .length > 0 && (
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  printInterviewLetters();
                                }}
                                disabled={pdfPrintDisabled}
                              >
                                {commonLabels.BUTTON_PRINT}
                              </button>
                            )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {interviewQualifiedCandidateData &&
              interviewQualifiedCandidateData.interviewLetters &&
              interviewQualifiedCandidateData.interviewLetters.length > 0 && (
                <div ref={pdfRef} className="answerKeyTable" id="AnswerKey">
                  {interviewQualifiedCandidateData &&
                    interviewQualifiedCandidateData.interviewLetters &&
                    interviewQualifiedCandidateData.interviewLetters.length >
                    0 &&
                    interviewQualifiedCandidateData.interviewLetters.map(
                      (dt, i) => {
                        return (
                          <div key={i}>
                            <br />
                            <h5>INTERVIEW CENTRE : {dt.interviewCentername}</h5>
                            <br />

                            <table className="table table-bordered">
                              <thead className="thead-light">
                                <tr>
                                  <th className="text-center">{label.No}</th>
                                  <th>{label.INTNO}</th>
                                  <th>{label.ROLLNO}</th>
                                  <th>{label.CANDIDTESNAME}</th>
                                  <th>{label.INTERVIEWDATEANDTIME}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {dt &&
                                  dt.interviewList &&
                                  dt.interviewList.length > 0 &&
                                  dt.interviewList.map((ele, ind) => {
                                    return (
                                      <tr key={ind}>
                                        <td className="text-center">{ind + 1}</td>
                                        <td>{ele?.interviewNo}</td>
                                        <td>{ele?.rollNo}</td>
                                        <td>{ele.candidateName}</td>
                                        <td>
                                          <span>
                                            {ele.interviewDate !== null &&
                                              dayjs(ele.interviewDate).format(
                                                "DD/MM/YYYY"
                                              )}
                                          </span>{" "}
                                          <span>
                                            {ele.interviewTime !== null &&
                                              ele.interviewTime}
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        );
                      }
                    )}
                </div>
              )}


            {selectedExam && interviewData && interviewData.interviewScheduleApprovalDtos?.length > 0 && (
              <div ref={pdfRef} className="answerKeyTable" id="interviewList">



                <>
                  <h5 className="LeftText bold-label">Interview Schedule</h5>
                  {Object.entries(groupedDataByVenue).map(([venueName, data], index) => (
                    <div key={index}>
                      <label className="LeftText bold-label">{label.InterviewCentre} &nbsp; {venueName}</label>
                      <br /><br />
                      <table className="table text-center">
                        <thead className="bold-label">
                          <tr>
                            <th id="topbotborder">{label.InterviewNo}</th>
                            <th className="text-left" id="topbotborder">{label.RollNo}</th>
                            <th className="text-left" id="topbotborder">{label.CandidatesName}</th>
                            <th id="topbotborder">{label.InterviewDate}</th>
                            <th id="topbotborder">{label.InterviewTime}</th>
                          </tr>

                        </thead>
                        <tbody>
                          {data.map((item, dataIndex) => (
                            <tr key={dataIndex}>
                              <td id="bottomborder">{item.interviewNumber}</td>
                              <td className="text-left" id="bottomborder">{item.rollId}</td>
                              <td className="text-left" id="bottomborder">{item.candidateName}</td>
                              <td id="bottomborder">{moment(item.interviewDate, "DD-MM-YYYY").format("DD/MM/YYYY")}</td>
                              <td id="bottomborder">{item.interviewTime}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))}
                </>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "Approvals"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="Approvals"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            {allUnapprovalEntityList &&
              allUnapprovalEntityList.entityApprovalDtoList &&
              allUnapprovalEntityList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}>
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allUnapprovalEntityList &&
                      allUnapprovalEntityList.entityApprovalDtoList &&
                      allUnapprovalEntityList.entityApprovalDtoList.length >
                      0 &&
                      allUnapprovalEntityList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className="word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-15">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>

                              <td className="w-10 word-break  width-20">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.examName &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.examName}{" "}
                                <br />{" "}
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam.nameDvng}
                              </td>
                              <td >
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>

                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.firstName
                                }{" "}
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.lastName
                                }
                              </td>

                              <td className="word-break width-10">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-15">
                                {(session.roleName == 'superadmin' || session.roleName == 'desk officer') &&
                                  <button
                                    type="button"
                                    className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                    onClick={() => {
                                      handleApprovalUser(ele);
                                    }}
                                  >
                                    {commonLabels.REVIEW}
                                  </button>}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_answerkey_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={allUnapprovalEntityList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "qualifiedCandidate"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="qualifiedCandidate"
            role="tabpanel"
            aria-labelledby="list-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form
                  name="qualifiedCandidateForm"
                  encType="multipart/form-data"
                >
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option key={index}>{element}</option>
                              // <option key={index} value={element.id}>
                              //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                              // </option>
                            ))}
                        </select>
                        {_.get("selectedYear1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-5">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getMainsAdvertisement &&
                            getMainsAdvertisement.length > 0 &&
                            getMainsAdvertisement
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo1.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className=" col-md-4">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-6 ">
                        {session.roleName === "superadmin" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={qualifiedButton}
                              onClick={() => DownloadCandidateList()}
                            >
                              {commonLabels.DownloadCandidate}
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {approvalEntityModal && (
            <InterviewScheduleApprovalEntity
              showModal={approvalEntityModal}
              setShowModal={setApprovalEntityModal}
              setSelectedApprovalEntity={selectedApprovalEntity}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default GenerateInterviewSchedule;
